var map = {
	"./afb-color.svg": 1821,
	"./afb.svg": 1822,
	"./alb-color.svg": 1823,
	"./alb.svg": 1824,
	"./amb-color.svg": 1825,
	"./amb.svg": 1826,
	"./bbbaidja-color.svg": 1827,
	"./bbbaidjaxxx-color.svg": 1828,
	"./bdinidjaxxx-color.svg": 1829,
	"./bimb-color.svg": 1830,
	"./bimb.svg": 1831,
	"./bkr-color.svg": 1832,
	"./bkr.svg": 1833,
	"./bmriidja-color.svg": 1834,
	"./bniaidja-color.svg": 1835,
	"./bninidja-color.svg": 1836,
	"./bninidjaxxx-color.svg": 1837,
	"./bpay-color.svg": 1838,
	"./brinidja002-color.svg": 1839,
	"./bsmdidjaxxx-color.svg": 1840,
	"./bsn-color.svg": 1841,
	"./bsn.svg": 1842,
	"./btanidjaxxx-color.svg": 1843,
	"./cenaidja-color.svg": 1844,
	"./cenaidjaxxx-color.svg": 1845,
	"./cimb-color.svg": 1846,
	"./cimb.svg": 1847,
	"./citi-color.svg": 1848,
	"./citi.svg": 1849,
	"./default-bank-icon-color.png": 1850,
	"./default-bank-icon.png": 1851,
	"./gxbank-color.svg": 1852,
	"./hlb-color.svg": 1853,
	"./hlb.svg": 1854,
	"./hsbc-color.svg": 1855,
	"./hsbc.svg": 1856,
	"./ibbkidjaxxx-color.svg": 1857,
	"./kwh-color.svg": 1858,
	"./kwh.svg": 1859,
	"./mbb-color.svg": 1860,
	"./mbb.svg": 1861,
	"./nispidjaxxx-color.svg": 1862,
	"./ocbc-color.svg": 1863,
	"./ocbc.svg": 1864,
	"./pbb-color.svg": 1865,
	"./pbb.svg": 1866,
	"./pinbidja-color.svg": 1867,
	"./rhb-b.svg": 1868,
	"./rhb-color-b.svg": 1869,
	"./rhb-color.svg": 1870,
	"./rhb.svg": 1871,
	"./scb-color.svg": 1872,
	"./scb.svg": 1873,
	"./tng-color.svg": 1874,
	"./uob-color.svg": 1875,
	"./uob.svg": 1876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;